<template>
  <SolutionPageLayout title="Tradeshows & Exhibitions" section="Type">
    <p>
      Exhibitions are built around foot traffic, exhibitor ROI, and dense floorplans—your technology has to keep pace with the show floor, not slow it down.
    </p>
    <p>
      Entegy supports exhibitor and delegate journeys end-to-end: lead capture, interactive floorplans, kiosk check-in, and real-time visibility for organisers and partners.
    </p>
  </SolutionPageLayout>
</template>

<script setup>
import SolutionPageLayout from './SolutionPageLayout.vue'
</script>
